document.addEventListener('DOMContentLoaded', async function () {

  /* =========================================================
     SETTINGS
  ========================================================= */

  const TRIAL_HANDLE = 'heart-miracle®-bp™-trial';
  const MAX_QTY = 2;
  const LIMIT_MESSAGE = 'Maximum 2 trial products per order.';

  let trialVariantIds = [];
  let cachedTrialQty = 0;

  let trialAddInProgress = false;
  let cartUpdateInProgress = false;
  let validationInProgress = false;


  /* =========================================================
     LOAD TRIAL VARIANT IDS
  ========================================================= */

  async function loadTrialVariants() {

    try {

      const response = await fetch(
        '/products/' + encodeURIComponent(TRIAL_HANDLE) + '.js',
        {
          credentials: 'same-origin'
        }
      );

      if (!response.ok) {
        return;
      }

      const product = await response.json();

      trialVariantIds = product.variants.map(function (variant) {
        return Number(variant.id);
      });

    } catch (error) {

      console.error(
        'Trial limiter: unable to load trial variants.',
        error
      );
    }
  }


  /* =========================================================
     GET CART
  ========================================================= */

  async function getCart() {

    try {

      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        return null;
      }

      return await response.json();

    } catch (error) {

      console.error(
        'Trial limiter: unable to load cart.',
        error
      );

      return null;
    }
  }


  /* =========================================================
     GET TOTAL TRIAL QUANTITY
  ========================================================= */

  function getTrialQuantity(cart) {

    if (!cart || !Array.isArray(cart.items)) {
      return 0;
    }

    return cart.items.reduce(function (total, item) {

      if (
        trialVariantIds.includes(
          Number(item.variant_id)
        )
      ) {
        total += Number(item.quantity || 0);
      }

      return total;

    }, 0);
  }


  /* =========================================================
     TRIAL PRODUCT PAGE?
  ========================================================= */

  function isTrialProductPage() {

    try {

      return decodeURIComponent(
        window.location.pathname
      ).includes(
        '/products/' + TRIAL_HANDLE
      );

    } catch (error) {

      return false;
    }
  }


  /* =========================================================
     LIMIT MESSAGE
  ========================================================= */

  function showLimitMessage() {

    let toast =
      document.getElementById(
        'trial-limit-toast'
      );


    if (!toast) {

      toast =
        document.createElement('div');

      toast.id =
        'trial-limit-toast';

      toast.textContent =
        LIMIT_MESSAGE;


      Object.assign(
        toast.style,
        {
          position: 'fixed',
          bottom: '25px',
          left: '50%',
          transform: 'translateX(-50%)',
          background: '#222',
          color: '#fff',
          padding: '12px 20px',
          borderRadius: '5px',
          zIndex: '999999',
          fontSize: '14px',
          textAlign: 'center',
          maxWidth: '90%',
          boxShadow:
            '0 4px 15px rgba(0,0,0,.2)'
        }
      );


      document.body.appendChild(
        toast
      );
    }


    toast.style.display =
      'block';


    clearTimeout(
      toast.hideTimer
    );


    toast.hideTimer =
      setTimeout(function () {

        toast.style.display =
          'none';

      }, 2500);
  }


  /* =========================================================
     FIND CART ITEM CONTAINER

     Expanded selectors to support Shopitized / AJAX carts
  ========================================================= */

  function getCartRow(element) {

    if (!element) {
      return null;
    }


    return element.closest(
      '.cart-item,' +
      '.cart__item,' +
      '[data-cart-item],' +
      '[data-cart-item-key],' +
      '[data-line-item],' +
      '[data-line],' +
      '.mini-cart-item,' +
      '.mini-cart__item,' +
      '.drawer__cart-item,' +
      '.cart-drawer-item,' +
      '.cart-drawer__item,' +
      '.ajaxcart__row,' +
      '.ajaxcart__product,' +
      '.ajax-cart-item,' +
      '.cart-item__wrapper,' +
      '.cart-product,' +
      '.cart__product,' +
      '.cart__row'
    );
  }


  /* =========================================================
     DOES ELEMENT BELONG TO TRIAL PRODUCT?
  ========================================================= */

  function isTrialCartRow(element) {

    let row = getCartRow(element);


    /*
      If the normal row selectors don't work,
      walk up the DOM manually looking for
      the product URL.
    */

    if (!row) {

      let parent = element;

      for (
        let i = 0;
        i < 8 && parent;
        i++
      ) {

        if (
          parent.querySelector &&
          parent.querySelector(
            'a[href*="/products/"]'
          )
        ) {

          row = parent;
          break;
        }

        parent =
          parent.parentElement;
      }
    }


    if (!row) {
      return false;
    }


    /* -------------------------
       Check product URL
    ------------------------- */

    const links =
      row.querySelectorAll(
        'a[href*="/products/"]'
      );


    for (const link of links) {

      try {

        const href =
          decodeURIComponent(
            link.getAttribute('href') || ''
          );


        if (
          href.includes(
            '/products/' + TRIAL_HANDLE
          )
        ) {
          return true;
        }

      } catch (error) {}
    }


    /* -------------------------
       Check product handle
    ------------------------- */

    const productHandle =
      row.dataset.productHandle ||
      row.getAttribute(
        'data-product-handle'
      ) ||
      '';


    if (
      productHandle ===
      TRIAL_HANDLE
    ) {
      return true;
    }


    /* -------------------------
       Check variant ID
    ------------------------- */

    const possibleVariantIds = [
      row.dataset.variantId,
      row.getAttribute(
        'data-variant-id'
      ),
      row.dataset.id,
      row.getAttribute(
        'data-id'
      )
    ];


    for (
      const possibleId
      of possibleVariantIds
    ) {

      if (
        possibleId &&
        trialVariantIds.includes(
          Number(possibleId)
        )
      ) {
        return true;
      }
    }


    /* -------------------------
       Check hidden variant input
    ------------------------- */

    const variantInput =
      row.querySelector(
        'input[name="id"]'
      );


    if (
      variantInput &&
      trialVariantIds.includes(
        Number(variantInput.value)
      )
    ) {
      return true;
    }


    return false;
  }


  /* =========================================================
     FIND QUANTITY INPUT
  ========================================================= */

  function getQuantityInput(row) {

    if (!row) {
      return null;
    }


    return row.querySelector(
      'input[name="updates[]"],' +
      'input[name^="updates["],' +
      'input[name="quantity"],' +
      'input[type="number"],' +
      'input.quantity,' +
      'input.qty,' +
      '.quantity input'
    );
  }


  /* =========================================================
     FIND PLUS BUTTON
  ========================================================= */

  function getPlusButton(row) {

    if (!row) {
      return null;
    }


    return row.querySelector(
      '.plus,' +
      '.quantity-plus,' +
      '.qty-plus,' +
      '.quantity__button[name="plus"],' +
      '[name="plus"],' +
      '[data-quantity-plus],' +
      '[data-qty-plus],' +
      '[data-action="increase"],' +
      '[data-action="increment"],' +
      '[data-increase],' +
      'button[aria-label*="Increase"],' +
      'button[aria-label*="increase"],' +
      'button[aria-label*="plus"],' +
      'button[aria-label*="Plus"]'
    );
  }


  /* =========================================================
     CHECK WHETHER CLICKED ELEMENT IS A PLUS BUTTON
  ========================================================= */

  function findPlusButton(element) {

    if (!element || !element.closest) {
      return null;
    }


    return element.closest(
      '.plus,' +
      '.quantity-plus,' +
      '.qty-plus,' +
      '.quantity__button[name="plus"],' +
      '[name="plus"],' +
      '[data-quantity-plus],' +
      '[data-qty-plus],' +
      '[data-action="increase"],' +
      '[data-action="increment"],' +
      '[data-increase],' +
      'button[aria-label*="Increase"],' +
      'button[aria-label*="increase"],' +
      'button[aria-label*="plus"],' +
      'button[aria-label*="Plus"]'
    );
  }


  /* =========================================================
     CHECK WHETHER CLICKED ELEMENT IS A MINUS BUTTON
  ========================================================= */

  function findMinusButton(element) {

    if (!element || !element.closest) {
      return null;
    }


    return element.closest(
      '.minus,' +
      '.quantity-minus,' +
      '.qty-minus,' +
      '.quantity__button[name="minus"],' +
      '[name="minus"],' +
      '[data-quantity-minus],' +
      '[data-qty-minus],' +
      '[data-action="decrease"],' +
      '[data-action="decrement"],' +
      '[data-decrease],' +
      'button[aria-label*="Decrease"],' +
      'button[aria-label*="decrease"],' +
      'button[aria-label*="minus"],' +
      'button[aria-label*="Minus"]'
    );
  }


  /* =========================================================
     DISABLE / ENABLE PLUS BUTTON
  ========================================================= */

  function setPlusButtonState(
    button,
    disabled
  ) {

    if (!button) {
      return;
    }


    if (disabled) {

      button.disabled = true;

      button.setAttribute(
        'disabled',
        'disabled'
      );

      button.setAttribute(
        'aria-disabled',
        'true'
      );

      button.style.opacity =
        '0.4';

      button.style.cursor =
        'not-allowed';

      /*
        Do NOT use pointer-events:none here.

        We still want our listener to receive
        the click if the theme ignores disabled.
      */

    } else {

      button.disabled = false;

      button.removeAttribute(
        'disabled'
      );

      button.setAttribute(
        'aria-disabled',
        'false'
      );

      button.style.opacity =
        '';

      button.style.cursor =
        '';
    }
  }


  /* =========================================================
     UPDATE CART DRAWER UI
  ========================================================= */

  function updateCartDrawerUI() {

    const possibleInputs =
      document.querySelectorAll(
        'input[name="updates[]"],' +
        'input[name^="updates["],' +
        'input[name="quantity"],' +
        'input[type="number"],' +
        'input.quantity,' +
        'input.qty,' +
        '.quantity input'
      );


    possibleInputs.forEach(
      function (input) {

        if (
          !isTrialCartRow(input)
        ) {
          return;
        }


        input.min = 1;
        input.max = MAX_QTY;


        let currentQty =
          Number(
            input.value || 0
          );


        if (
          currentQty >
          MAX_QTY
        ) {

          input.value =
            MAX_QTY;

          currentQty =
            MAX_QTY;
        }


        const row =
          getCartRow(input) ||
          input.parentElement;


        let plusButton =
          getPlusButton(row);


        /*
          Most important change:

          disable PLUS based on the actual
          cached cart quantity, not merely
          what the drawer currently displays.
        */

        const shouldDisable =
          cachedTrialQty >=
          MAX_QTY;


        setPlusButtonState(
          plusButton,
          shouldDisable
        );
      }
    );


    /*
      Also find plus buttons directly.

      This catches themes where the plus button
      and quantity input are wrapped differently.
    */

    document.querySelectorAll(
      '.plus,' +
      '.quantity-plus,' +
      '.qty-plus,' +
      '.quantity__button[name="plus"],' +
      '[name="plus"],' +
      '[data-quantity-plus],' +
      '[data-qty-plus],' +
      '[data-action="increase"],' +
      '[data-action="increment"],' +
      '[data-increase]'
    ).forEach(
      function (button) {

        if (
          !isTrialCartRow(button)
        ) {
          return;
        }


        setPlusButtonState(
          button,
          cachedTrialQty >=
          MAX_QTY
        );
      }
    );
  }


  /* =========================================================
     UPDATE PRODUCT PAGE UI
  ========================================================= */

  function updateProductPageUI() {

    if (
      !isTrialProductPage()
    ) {
      return;
    }


    const remaining =
      Math.max(
        MAX_QTY -
        cachedTrialQty,
        0
      );


    document.querySelectorAll(
      'input[name="quantity"]'
    ).forEach(
      function (input) {

        input.min = 1;


        if (
          remaining > 0
        ) {

          input.max =
            remaining;


          if (
            Number(
              input.value || 1
            ) >
            remaining
          ) {

            input.value =
              remaining;
          }

        } else {

          input.max = 1;

          if (
            Number(
              input.value || 1
            ) > 1
          ) {
            input.value = 1;
          }
        }
      }
    );


    const addButtons =
      document.querySelectorAll(
        'form[action*="/cart/add"] button[type="submit"],' +
        'form[action*="/cart/add"] input[type="submit"]'
      );


    addButtons.forEach(
      function (button) {

        if (
          !button.dataset
            .trialOriginalText
        ) {

          button.dataset
            .trialOriginalText =
            button.tagName ===
            'INPUT'
              ? button.value
              : button.textContent.trim();
        }


        if (
          cachedTrialQty >=
          MAX_QTY ||
          trialAddInProgress
        ) {

          button.disabled =
            true;


          if (
            button.tagName ===
            'INPUT'
          ) {

            button.value =
              'LIMIT 2 PER ORDER';

          } else {

            button.textContent =
              'LIMIT 2 PER ORDER';
          }

        } else {

          button.disabled =
            false;


          if (
            button.tagName ===
            'INPUT'
          ) {

            button.value =
              button.dataset
                .trialOriginalText;

          } else {

            button.textContent =
              button.dataset
                .trialOriginalText;
          }
        }
      }
    );
  }


  /* =========================================================
     UPDATE ALL UI
  ========================================================= */

  function updateUI(cart) {

    if (cart) {

      cachedTrialQty =
        getTrialQuantity(
          cart
        );
    }


    updateProductPageUI();
    updateCartDrawerUI();
  }


  /* =========================================================
     CHANGE CART LINE
  ========================================================= */

  async function changeCartItem(
    line,
    quantity
  ) {

    try {

      const response =
        await fetch(
          '/cart/change.js',
          {
            method: 'POST',

            credentials:
              'same-origin',

            headers: {
              'Content-Type':
                'application/json',

              'Accept':
                'application/json'
            },

            body:
              JSON.stringify({
                line: line,
                quantity: quantity
              })
          }
        );


      if (!response.ok) {
        return null;
      }


      return await response.json();

    } catch (error) {

      console.error(
        'Trial limiter: cart change failed.',
        error
      );

      return null;
    }
  }


  /* =========================================================
     VALIDATE CART

     Secondary safety net.
  ========================================================= */

  async function validateCart() {

    if (
      validationInProgress
    ) {
      return;
    }


    validationInProgress =
      true;


    try {

      let cart =
        await getCart();


      if (!cart) {
        return;
      }


      let runningQty = 0;


      for (
        let i = 0;
        i < cart.items.length;
        i++
      ) {

        const item =
          cart.items[i];


        if (
          !trialVariantIds.includes(
            Number(
              item.variant_id
            )
          )
        ) {
          continue;
        }


        const remaining =
          MAX_QTY -
          runningQty;


        if (
          remaining <= 0
        ) {

          cart =
            await changeCartItem(
              i + 1,
              0
            );

          showLimitMessage();

          break;
        }


        if (
          item.quantity >
          remaining
        ) {

          cart =
            await changeCartItem(
              i + 1,
              remaining
            );

          showLimitMessage();

          break;
        }


        runningQty +=
          Number(
            item.quantity
          );
      }


      if (!cart) {

        cart =
          await getCart();
      }


      if (cart) {

        cachedTrialQty =
          getTrialQuantity(
            cart
          );

        updateUI(cart);
      }


    } catch (error) {

      console.error(
        'Trial limiter: validation failed.',
        error
      );

    } finally {

      validationInProgress =
        false;
    }
  }


  /* =========================================================
     CRITICAL FIX:
     BLOCK PLUS CLICK BEFORE SHOPITIZED

     Runs in CAPTURE phase.

     If Shopify says we already have 2,
     the click never reaches Shopitized.
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      const plusButton =
        findPlusButton(
          event.target
        );


      if (!plusButton) {
        return;
      }


      if (
        !isTrialCartRow(
          plusButton
        )
      ) {
        return;
      }


      /*
        THIS is the important condition.

        Do not trust the drawer input.
        Trust our cached real cart quantity.
      */

      if (
        cachedTrialQty >=
        MAX_QTY
      ) {

        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();


        const row =
          getCartRow(
            plusButton
          );


        const input =
          getQuantityInput(
            row
          );


        if (input) {

          input.value =
            MAX_QTY;

          input.max =
            MAX_QTY;
        }


        setPlusButtonState(
          plusButton,
          true
        );


        showLimitMessage();


        return false;
      }


      /*
        If quantity is currently 1,
        immediately assume this click
        will bring it to 2.

        This closes the race-condition
        window before Shopitized responds.
      */

      if (
        cachedTrialQty ===
        MAX_QTY - 1
      ) {

        cachedTrialQty =
          MAX_QTY;


        setPlusButtonState(
          plusButton,
          true
        );


        updateProductPageUI();
      }

    },

    true
  );


  /* =========================================================
     MINUS BUTTON

     Immediately reduce local quantity so UI unlocks quickly.
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      const minusButton =
        findMinusButton(
          event.target
        );


      if (!minusButton) {
        return;
      }


      if (
        !isTrialCartRow(
          minusButton
        )
      ) {
        return;
      }


      const row =
        getCartRow(
          minusButton
        );


      const input =
        getQuantityInput(
          row
        );


      if (!input) {
        return;
      }


      const currentQty =
        Number(
          input.value || 0
        );


      if (
        currentQty > 0
      ) {

        cachedTrialQty =
          Math.max(
            cachedTrialQty - 1,
            0
          );


        updateProductPageUI();


        const plusButton =
          getPlusButton(
            row
          );


        setPlusButtonState(
          plusButton,
          false
        );
      }


      /*
        Sync against real Shopify cart
        shortly afterwards.
      */

      setTimeout(
        async function () {

          const cart =
            await getCart();


          if (cart) {

            cachedTrialQty =
              getTrialQuantity(
                cart
              );

            updateUI(cart);
          }

        },
        250
      );

    },

    true
  );


  /* =========================================================
     MANUAL CART INPUT

     Prevent typing 3, 4, etc.
  ========================================================= */

  document.addEventListener(
    'input',
    function (event) {

      const input =
        event.target;


      if (
        !input.matches(
          'input[name="updates[]"],' +
          'input[name^="updates["],' +
          'input[name="quantity"],' +
          'input[type="number"],' +
          'input.quantity,' +
          'input.qty,' +
          '.quantity input'
        )
      ) {
        return;
      }


      if (
        !isTrialCartRow(
          input
        )
      ) {
        return;
      }


      let qty =
        Number(
          input.value || 0
        );


      if (
        qty > MAX_QTY
      ) {

        event.preventDefault();

        event.stopPropagation();

        input.value =
          MAX_QTY;


        cachedTrialQty =
          MAX_QTY;


        showLimitMessage();

        updateCartDrawerUI();
        updateProductPageUI();
      }

    },

    true
  );


  /* =========================================================
     MANUAL CART CHANGE

     Secondary protection.
  ========================================================= */

  document.addEventListener(
    'change',
    function (event) {

      const input =
        event.target;


      if (
        !input.matches(
          'input[name="updates[]"],' +
          'input[name^="updates["],' +
          'input[name="quantity"],' +
          'input[type="number"],' +
          'input.quantity,' +
          'input.qty,' +
          '.quantity input'
        )
      ) {
        return;
      }


      if (
        !isTrialCartRow(
          input
        )
      ) {
        return;
      }


      let qty =
        Number(
          input.value || 0
        );


      if (
        qty > MAX_QTY
      ) {

        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();


        input.value =
          MAX_QTY;


        cachedTrialQty =
          MAX_QTY;


        showLimitMessage();

        updateUI();


        return false;
      }


      setTimeout(
        async function () {

          const cart =
            await getCart();


          if (cart) {

            cachedTrialQty =
              getTrialQuantity(
                cart
              );

            if (
              cachedTrialQty >
              MAX_QTY
            ) {

              await validateCart();

            } else {

              updateUI(cart);
            }
          }

        },
        200
      );

    },

    true
  );


  /* =========================================================
     PRODUCT PAGE QUANTITY
  ========================================================= */

  document.addEventListener(
    'input',
    function (event) {

      const input =
        event.target;


      if (
        !isTrialProductPage()
      ) {
        return;
      }


      if (
        !input.matches(
          'input[name="quantity"]'
        )
      ) {
        return;
      }


      const remaining =
        Math.max(
          MAX_QTY -
          cachedTrialQty,
          0
        );


      let requested =
        Number(
          input.value || 1
        );


      if (
        remaining <= 0
      ) {

        input.value = 1;

        showLimitMessage();

        return;
      }


      if (
        requested >
        remaining
      ) {

        input.value =
          remaining;

        showLimitMessage();
      }

    },

    true
  );


  /* =========================================================
     PRODUCT ADD TO CART

     Block rapid repeated submissions.
  ========================================================= */

  document.addEventListener(
    'submit',
    function (event) {

      const form =
        event.target;


      if (
        !form.matches(
          'form[action*="/cart/add"]'
        )
      ) {
        return;
      }


      if (
        !isTrialProductPage()
      ) {
        return;
      }


      const quantityInput =
        form.querySelector(
          'input[name="quantity"]'
        );


      const requestedQty =
        quantityInput
          ? Number(
              quantityInput.value ||
              1
            )
          : 1;


      if (
        trialAddInProgress
      ) {

        event.preventDefault();

        event.stopImmediatePropagation();

        showLimitMessage();

        return false;
      }


      const remaining =
        MAX_QTY -
        cachedTrialQty;


      if (
        remaining <= 0
      ) {

        event.preventDefault();

        event.stopImmediatePropagation();

        showLimitMessage();

        updateProductPageUI();

        return false;
      }


      if (
        requestedQty >
        remaining
      ) {

        event.preventDefault();

        event.stopImmediatePropagation();


        if (
          quantityInput
        ) {

          quantityInput.value =
            remaining;
        }


        showLimitMessage();


        return false;
      }


      /*
        Optimistic lock BEFORE Shopitized.
      */

      cachedTrialQty +=
        requestedQty;


      trialAddInProgress =
        true;


      updateProductPageUI();
      updateCartDrawerUI();


      setTimeout(
        async function () {

          const cart =
            await getCart();


          trialAddInProgress =
            false;


          if (cart) {

            cachedTrialQty =
              getTrialQuantity(
                cart
              );


            if (
              cachedTrialQty >
              MAX_QTY
            ) {

              await validateCart();

            } else {

              updateUI(cart);
            }
          }

        },
        500
      );

    },

    true
  );


  /* =========================================================
     WATCH SHOPIFY FETCH CALLS
  ========================================================= */

  const nativeFetch =
    window.fetch;


  window.fetch =
    async function () {

      const response =
        await nativeFetch.apply(
          this,
          arguments
        );


      try {

        const request =
          arguments[0];


        const url =
          typeof request ===
          'string'
            ? request
            : request &&
              request.url
              ? request.url
              : '';


        if (
          url.includes(
            '/cart/add'
          ) ||
          url.includes(
            '/cart/change'
          ) ||
          url.includes(
            '/cart/update'
          )
        ) {

          setTimeout(
            async function () {

              const cart =
                await getCart();


              trialAddInProgress =
                false;

              cartUpdateInProgress =
                false;


              if (!cart) {
                return;
              }


              cachedTrialQty =
                getTrialQuantity(
                  cart
                );


              if (
                cachedTrialQty >
                MAX_QTY
              ) {

                await validateCart();

              } else {

                updateUI(cart);
              }

            },
            100
          );
        }

      } catch (error) {

        console.error(
          'Trial limiter fetch watcher:',
          error
        );
      }


      return response;
    };


  /* =========================================================
     WATCH XMLHttpRequest

     Some older Shopify themes such as
     Shopitized may use XMLHttpRequest instead
     of fetch for the cart drawer.
  ========================================================= */

  const originalXHROpen =
    XMLHttpRequest.prototype.open;


  XMLHttpRequest.prototype.open =
    function (
      method,
      url
    ) {

      this._trialLimiterURL =
        url;


      return originalXHROpen
        .apply(
          this,
          arguments
        );
    };


  const originalXHRSend =
    XMLHttpRequest.prototype.send;


  XMLHttpRequest.prototype.send =
    function () {

      const xhr =
        this;


      xhr.addEventListener(
        'load',
        function () {

          const url =
            String(
              xhr._trialLimiterURL ||
              ''
            );


          if (
            url.includes(
              '/cart/add'
            ) ||
            url.includes(
              '/cart/change'
            ) ||
            url.includes(
              '/cart/update'
            )
          ) {

            setTimeout(
              async function () {

                const cart =
                  await getCart();


                trialAddInProgress =
                  false;


                if (!cart) {
                  return;
                }


                cachedTrialQty =
                  getTrialQuantity(
                    cart
                  );


                if (
                  cachedTrialQty >
                  MAX_QTY
                ) {

                  await validateCart();

                } else {

                  updateUI(cart);
                }

              },
              100
            );
          }
        }
      );


      return originalXHRSend
        .apply(
          this,
          arguments
        );
    };


  /* =========================================================
     DOM OBSERVER

     Re-apply disabled + button whenever
     Shopitized redraws the cart drawer.
  ========================================================= */

  let observerTimer;


  const observer =
    new MutationObserver(
      function () {

        clearTimeout(
          observerTimer
        );


        observerTimer =
          setTimeout(
            function () {

              updateCartDrawerUI();
              updateProductPageUI();

            },
            50
          );
      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  /* =========================================================
     INITIALIZATION
  ========================================================= */

  await loadTrialVariants();


  const initialCart =
    await getCart();


  if (initialCart) {

    cachedTrialQty =
      getTrialQuantity(
        initialCart
      );


    /*
      Correct an existing cart if somebody
      already has more than 2.
    */

    if (
      cachedTrialQty >
      MAX_QTY
    ) {

      await validateCart();

    } else {

      updateUI(
        initialCart
      );
    }
  }

});